import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Conto cliente Fielmann",
    tabs: {
      login: "Accedi",
      signup: "Registrati",
      ariaLabel: "Autenticazione",
    },
    languageSwitcher: {
      label: "Seleziona la lingua",
    },
    password: {
      show: "Mostra password",
      hide: "Nascondi password",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Piè di pagina",
      customerService: "Contatti",
      legalNotice: "Dati societari",
      dataProtection: "Tutela dei dati",
    },
    loading: {
      ariaLabel: "Solo un momento, per favore...",
      content: "Caricamento dei contenuti.",
    },
  },
  login: {
    subtitle: "Accedi con la tua e-mail e la tua password.",
    form: {
      emailLabel: "E-mail *",
      passwordLabel: "Password *",
      forgotPassword: "Password dimenticata?",
      submitButton: "Accedi",
      credentialError: "E-mail e password non corrispondono.",
      genericError: "Si è verificato un errore. Riprova più tardi.",
    },
  },
  signup: {
    subtitle: {
      before: "Approfitta dei ",
      highlight: "vantaggi",
      after: " e crea il tuo conto cliente Fielmann.",
    },
    benefits: {
      popoverHeading: "I tuoi vantaggi:",
      closeLabel: "Chiudi",
      items: {
        orders:
          "Tutti gli ordini Fielmann, incluso lo stato dell’ordine, in un unico riepilogo.",
        visionValues:
          "Riutilizza i valori dei tuoi occhiali per il prossimo ordine.",
        appointments: "Prenota e gestisci i tuoi appuntamenti.",
        reorders: "Effettua facilmente i riordini online.",
      },
    },
    form: {
      firstNameLabel: "Nome *",
      lastNameLabel: "Cognome *",
      emailLabel: "E-mail *",
      passwordLabel: "Password *",
      passwordRepeatLabel: "Conferma password *",
      submitButton: "Registrati",
      errorTitle: "Non è stato possibile creare il conto cliente.",
      errorMessage: "Controlla i dati inseriti o riprova più tardi.",
      genericError: "Si è verificato un errore. Riprova più tardi.",
    },
    consents: {
      requiredError: "Presta il consenso richiesto.",
      unavailableError: "Si è verificato un errore. Riprova più tardi.",
      required: {
        headline: "Consenso per il conto cliente",
        subline:
          "Per mostrarti tutti i contenuti nel tuo conto cliente (ad es. acquisti o appuntamenti), abbiamo bisogno del tuo consenso.",
      },
      optional: {
        headline: "Vuoi ricevere pubblicità personalizzata?",
        subline:
          "Puoi scegliere: con il tuo consenso ricevi offerte e informazioni su misura per te. Senza consenso, utilizzi il tuo conto cliente senza pubblicità personalizzata.",
      },
    },
  },
  emailVerification: {
    subtitle: "Non riesci ad accedere?",
    alertTitle: "Conferma prima il tuo indirizzo e-mail.",
    alertBody:
      "Conferma prima il tuo indirizzo e-mail per attivare il tuo conto Fielmann.",
    alertSpamHint: "Non trovi l’e-mail? Controlla anche la cartella spam.",
    resendButton: "Richiedi di nuovo l’e-mail",
    backToLogin: "Torna all’accesso",
  },
  setPassword: {
    subtitle: "Ora puoi impostare la tua password.",
    emailLabel: "E-mail *",
    passwordLabel: "Password *",
    passwordRepeatLabel: "Conferma password *",
    submitButton: "Salva password",
    backToLogin: "Vai all’accesso",
    successTitle: "La tua password è stata salvata con successo.",
    successBody: "Ora puoi accedere.",
  },
  toasts: {
    missingRequiredFields:
      "Compila tutti i campi obbligatori ancora mancanti per continuare.",
  },
  validation: {
    passwordRequired: "Inserisci una password.",
    passwordRepeatRequired: "Inserisci nuovamente la password.",
    firstNameTooLong: "Il nome non deve superare i 30 caratteri.",
    firstNameRequired: "Inserisci un nome.",
    firstNameInvalidFormat: "Inserisci un nome valido.",
    lastNameTooLong: "Il cognome non deve superare i 30 caratteri.",
    lastNameRequired: "Inserisci un cognome.",
    lastNameInvalidFormat: "Inserisci un cognome valido.",
    emailTooLong: "L’indirizzo e-mail è troppo lungo.",
    emailRequired: "Inserisci un indirizzo e-mail.",
    emailInvalidFormat: "Inserisci un indirizzo e-mail valido.",
    passwordMatchesEmail:
      "La password non può corrispondere all’indirizzo e-mail.",
    passwordMismatch: "Le password non coincidono.",
  },
  passwordRequirements: {
    minimumLength: "Almeno 10 caratteri",
    mixedCase: "Almeno una lettera maiuscola e una minuscola",
    hasNumber: "Almeno un numero",
    specialCharactersAllowed:
      "I caratteri speciali sono consentiti (ad es. !@#$%^&*)",
  },
};
